import React from 'react'

const CTA = (props) => {
  return (
      <a className={props.class} href={props.link} target={props.window}>{props.text}</a>
  )
}

export default CTA